import { createInstance, Types } from '@amplitude/analytics-browser';

export const DW_INSTANCE_NAME = 'dw_only';
export const DW_ONLY_MARKER = 'dw-only';
export const DW_EVENT_CHANNEL_KEY = 'event_channel';
export const DW_RECIPIENT_ID_KEY = 'recipient_id';

export interface DwAmplitudeEvent {
    name: string;
    properties: Record<string, unknown>;
}

export interface DwAmplitudeInstance {
    init: () => Promise<void>;
    trackDwEvent: (event: DwAmplitudeEvent) => Promise<void>;
}

export function createDwAmplitudeInstance(
    token: string,
    serverUrl: string
): DwAmplitudeInstance {
    const instance = createInstance();
    return {
        init: () =>
            instance.init(token, {
                instanceName: DW_INSTANCE_NAME,
                serverUrl,
                optOut: false,
                autocapture: false,
                logLevel: Types.LogLevel.None,
                trackingOptions: { ipAddress: false },
                enableRequestBodyCompression: true,
            }).promise,
        trackDwEvent: async (event: DwAmplitudeEvent) => {
            await instance.track(event.name, {
                ...event.properties,
                [DW_ONLY_MARKER]: true,
            }).promise;
            await instance.flush().promise;
        },
    };
}
